import React from "react";
import LoanInstallmentListTable from "./components/LoanInstallmentListTable";
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const LoanInstallmentList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Loan Installment List</HeadingOne>
                    <AddItemBtn url="add-loan-installment" title="Pay Installment" />
                </>
            }
        >
            <div className="col-12">
                <LoanInstallmentListTable />
            </div>
        </PageBody>
    );
};

export default LoanInstallmentList;
